import * as $ from 'jquery';

export default (function () {
    window.stringUtils = {
        onlyNumbers: (str) => {
            return str.replace(/\D/g,'');
        },
        capitalize:(str) => {
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        },
    }
}());
